export const AUTH_CONFIG = {
  clientId: 'oSM5kNoYS76E6ps098tKAG3BpAm7QvTg',
  domain: 'shesaidyestome.eu.auth0.com',
  audience: 'https://shesaidyesto.me',
  callbackUrl: 'https://shesaidyesto.me/Callback'
}



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js